import * as React from 'react';

function SvgProgressInConsultation(props) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.65 19.66l1.16-2.43a7.57 7.57 0 01-2.56-5.58c0-4.59 4.4-8.25 9.75-8.25 5.36 0 9.75 3.66 9.75 8.25S17.35 19.9 12 19.9c-.9 0-1.8-.1-2.65-.3-.75.16-2.37.53-4.85 1.11a.75.75 0 01-.85-1.05zm2.76-2.32l-.73 1.56c1.81-.43 2.98-.7 3.52-.81a.75.75 0 01.34 0c.8.2 1.62.31 2.46.31 4.58 0 8.25-3.06 8.25-6.75 0-3.7-3.67-6.75-8.25-6.75s-8.25 3.06-8.25 6.75c0 1.82.89 3.53 2.45 4.8.26.21.35.58.21.89zm1.84-6.94a1 1 0 110 2 1 1 0 010-2zm7.55 0a1 1 0 010 2 1 1 0 110-2zm-3.77 0a1 1 0 110 2 1 1 0 010-2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgProgressInConsultation;
